/**
 * Configurações específicas para o cliente "CAIXA"
 */
const settings: ClientSettings = {
  name: "Caixa Aqui",
  benefitCardName: "Cartão de Benefícios CAIXA",
  theme: {
    token: {
      colorPrimary: "#005CA9",
      colorHighlight: "#4085BF",
    },
  },
  assets: {
    background: "/background.jpg",
    logo: "/logo.png",
    favicon: "/favicon.png",
    card: "",
    consignedCard: "",
  },
  cardExclusiveTheme: {
    name: "Cartão de Benefícios CAIXA",
    theme: {
      token: {
        colorPrimary: "#005CA9",
        colorHighlight: "#4085BF",
      },
    },
    assets: {
      background: "/background.jpg",
      logo: "",
      favicon: "",
    },
  },
};

export default settings;
